import { render, staticRenderFns } from "./RsaSchedaRelazioneSanitariaAssettoPsicopatologicoIngressoEditComponent.vue?vue&type=template&id=810ed2b2"
import script from "./RsaSchedaRelazioneSanitariaAssettoPsicopatologicoIngressoEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaSchedaRelazioneSanitariaAssettoPsicopatologicoIngressoEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports